import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import Home from './views/Home.vue'
import BulkSendBookingInvites from './views/BulkSendBookingInvites.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/bulk-send-booking-invites',
      name: 'Bulk Send Booking Invites',
      component: BulkSendBookingInvites
    },
    {
      path: '/markets',
      name: 'markets',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Markets.vue')
    },
    {
        path: '/market/:date', 
        //component: ListingPage,
        component: () => import(/* webpackChunkName: "market" */ './views/Market.vue'),
        name: 'market',
        beforeEnter: redirectIfNotMarket, 
    },
    {
        path: '/payments',
        name: 'payments',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ './views/Payments.vue')
    },
    {
        path: '/bookings',
        name: 'bookings',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "bookings" */ './views/Bookings.vue')
    },
    {
        path: '/payments/:id', 
        //component: ListingPage,
        component: () => import(/* webpackChunkName: "about" */ './views/Payment.vue'),
        name: 'payment',
        beforeEnter: redirectIfNotPayment, 
    },
    {
      path: '/stallholders',
      name: 'stallholders',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Stallholders.vue')
    },
    { path: '/stallholders/:id', 
    //component: ListingPage,
    component: () => import(/* webpackChunkName: "about" */ './views/Stallholder.vue'),
    name: 'stallholder',
    beforeEnter: redirectIfNotStallholder, 
  },
    {
      path: '/categories',
      name: 'categories',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Categories.vue')
    }
  ]
})

async function redirectIfNotStallholder (to, from, next) {
    // const user = await getUserState()
    // if (user === null) {
    //   next({ name: 'auth' })
    // } else {
    //   next()

  
    // }
console.log("have all hoder", store.state.have_all_stallholders)
    if(store.state.have_all_stallholders || store.getters.getStallholderById(to.params.id) ){
        console.log("we have datassss for ");
    }else{
        console.log("we need to fetch consle for-- "+to.params.id)
       
        const user = store.dispatch("loadStallholder", { id: to.params.id})
        .then(function (response) {
            // yay, you got a new phone
            console.log('fulfilled');
            console.log({response});
            //commit('addStallholder', response);
            store.commit('addStallholder', response);

        })
        .catch(function (error) {
            // oops, stallholde rnot found
            next({ name: 'stallholders' })
        });

        
    }
    next()

}

async function redirectIfNotPayment (to, from, next) {

    console.log("have all payment loaded?", store.state.have_all_payments)

    if(store.state.have_all_payments || store.getters.getPaymentById(to.params.id) ){
        console.log("we have payment data already");
    }else{
        console.log("we need to fetch payment data for "+to.params.id)
       
        const user = store.dispatch("loadPayment", { id: to.params.id})
        .then(function (response) {
            // yay, you got a new phone
            console.log('fulfilledi');
            console.log({response});
            store.commit('addPayment', response);

            if(response.stallholder_id && response.stallholder_id > 0) {
                store.dispatch("loadStallholder", { id: response.stallholder_id})
                .then(function (stallholderresponse) {
                    // yay, you got data
                    console.log('fulfilled stallhodler id..');
                    console.log({stallholderresponse});
                    store.commit('addStallholder', stallholderresponse);

                })
                .catch(function (error) {
                    // oops, stallholde rnot found
                    console.error("no stallholder data found..")
                });
            }else{
                console.log("must be guest booking no fetching required of stallhodler")
            }

        })
        .catch(function (error) {
            // oops, payment not found
            next({ name: 'payments' })
        });
    }
    next()

}

router.beforeEach((to, from, next) => {
  store.dispatch('fetchAccessToken');
  // eslint-disable-next-line 
console.log(to);
  if (to.fullPath !== '/') {
    if (!store.state.accessToken) {
      next('/');
    }
  }
  if (to.fullPath === '/') {
      // eslint-disable-next-line 
    console.log('yes');
    
    if (store.state.accessToken) {
        // eslint-disable-next-line 
  console.log('need to redirect to markerts');

      next('/markets');
    }else{

  // eslint-disable-next-line 
        console.log('yes2');
 // eslint-disable-next-line 
      console.log(store.state.accessToken)

      next();
    }
  }else{
    if (store.state.accessToken) {
      console.log('logged in');
    next();
    }else{
      console.log('not logged in');
      next('/');
    }
  }
  // if (to.fullPath === '/login') {
  //   if (store.state.isAuthenticated) {
  //     next('/markets');
  //   }
  // }

});

async function redirectIfNotMarket(to, from, next) {

  // is this valid market date

  axios.get(`/wisdom-markets/v1/markets/${to.params.date}`, {
      headers: {
        'Authorization': `Bearer ${store.state.accessToken}`,
      },
  }).then(({data}) => {
      next();
  }).catch((error)=>{
      console.warn(error.response.data.message);
      // oops, no market exists on that date, redirect
      next({ name: 'markets' })
  });
}

export default router